import Select from "react-select";
import { acatypelist, statemaster } from "../../../services/master";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { academycreate, academydetail } from "../../../services/admin";
import { toast } from "react-toastify";

export default function Addacademy() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [urllink, setUrllink] = useState("");
  const [aname, setAName] = useState("");
  const [acode, setACode] = useState("");
  const [atype, setAType] = useState("");
  const [tlist, setTList] = useState([]);
  const [addr, setAddr] = useState("");
  const [astate, setAState] = useState("");
  const [slist, setSList] = useState([]);
  const [adist, setADist] = useState("");
  const [acity, setACity] = useState("");
  const [aarea, setAArea] = useState("");
  const [apin, setAPin] = useState("");
  const [awebsite, setAWebsite] = useState("");
  const [aemail, setAEmail] = useState("");
  const [aphone, setAPhone] = useState("");

  const [pfile, setPFile] = useState("");
  const [purl, setPUrl] = useState("");
  const [acnt, setACnt] = useState("");

  const [aerrmsg, setAErrMsg] = useState("");

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);
    statemaster().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].name,
            });
          }
          setSList(arr);
        }
      }
    });

    acatypelist().then((res) => {
      if (res.status === true) {
        setTList(res.data);
      }
    });

    if (path === "academydetail") {
      academydetail(id).then((res) => {
        if (res.status === true) {
          if (res.data.details !== null) {
            setAName(res.data.details.name);
            setACode(res.data.details.code);
            setAType(res.data.details.type);
            setAddr(res.data.details.address);
            setADist(res.data.details.district);
            setACity(res.data.details.city);
            setAArea(res.data.details.area);
            setAPin(res.data.details.pincode);
            if (res.data.details.website !== null) {
              setAWebsite(res.data.details.website);
            }
            setAEmail(res.data.details.email);
            setAPhone(res.data.details.phone);
            if (res.data.details.logo !== null) {
              setPFile(res.data.path + res.data.details.logo);
              setPUrl(res.data.path + res.data.details.logo);
            }
            setACnt(res.data.details.student_count);

            statemaster().then((res1) => {
              if (res1.status === true) {
                let arr = [];
                if (res1.data.length > 0) {
                  for (let i = 0; i < res1.data.length; i++) {
                    if (res1.data[i].id == res.data.details.state) {
                      arr.push({
                        value: res1.data[i].id,
                        label: res1.data[i].name,
                      });
                    }
                  }
                  setAState(arr[0]);
                }
              }
            });
          }
        }
      });
    }
  }, [location.pathname]);

  const [photoerror, setPhotoError] = useState("");
  function photofile(event) {
    setPhotoError("");
    setPFile("");
    setPUrl("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setPUrl(URL.createObjectURL(event.target.files[0]));
        setPFile(event.target.files[0]);
      } else {
        setPhotoError("Logo should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Logo size should be less than 5MB");
      }
    }
  }

  function handleState(e) {
    if (e !== null) {
      setAState(e);
    } else {
      setAState("");
    }
  }

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAPhone(e.target.value);
    }
  };

  const handlePin = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAPin(e.target.value);
    }
  };

  const handleCount = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setACnt(e.target.value);
    }
  };
  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/logo/logo-small.png");
    ev.target.onerror = null;
  }

  const [aerror, setAError] = useState(false);

  function submitacademy(e) {
    e.preventDefault();
    setAError(true);
    setAErrMsg("");
    var valid=""
    if (
      aname !== "" &&
      acode !== "" &&
      atype !== "" &&
      addr !== "" &&
      astate !== "" &&
      adist !== "" &&
      acity !== "" &&
      apin !== "" &&
      aemail !== "" &&
      aphone !== ""
    ) {
      
     
      if (aphone !== "") {
        if (aphone.length < 10) {
          valid = "Phone Number should be 10 digits";
          setAErrMsg("Phone Number should be 10 digits");
        }
      }
      if(aemail !== ""){
        let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        if (!regEmail.test(aemail)) {
          valid = "Please Enter a valid Email";
          setAErrMsg("Please Enter a valid Email");
        }
      }
      if (apin !== "") {
        if (apin.length < 6) {
          valid = "Pincode should be 6 digits";
          setAErrMsg("Pincode should be 6 digits");
        }
      }
      if(valid === ""){
        setAError(false);
        setLoading(true);
  
        const temp = new FormData();
        temp.append("name", aname);
        temp.append("code", acode);
        temp.append("type", atype);
        temp.append("state", astate.value);
        temp.append("city", acity);
        temp.append("phone", aphone);
  
        temp.append("country", 1);
        temp.append("logo", pfile);
        temp.append("area", aarea);
        temp.append("pincode", apin);
        temp.append("address", addr);
        temp.append("website", awebsite);
        temp.append("district", adist);
        temp.append("student_count", acnt);
        temp.append("email", aemail);
        if (urllink === "academydetail") {
          temp.append("id", id);
        }
  
        academycreate(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            toast.success(res.message);
            navigate("/settings/allacademy");
          } else {
            setLoading(false);
            setAErrMsg(res.data);
          }
        });
      }
      
    }
  }
  const [loading, setLoading] = useState(false);
  return (
    <div>
      <div className="page-header">
        <div>
          {urllink === "addacademy" && (
            <h2 className="main-content-title tx-24 mg-b-5">Add Academy</h2>
          )}
          {urllink === "academydetail" && (
            <h2 className="main-content-title tx-24 mg-b-5">Academy Detail</h2>
          )}
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Settings</a>
            </li>
            {urllink === "addacademy" && (
              <li className="breadcrumb-item active" aria-current="page">
                Add Academy
              </li>
            )}
            {urllink === "academydetail" && (
              <li className="breadcrumb-item active" aria-current="page">
                Academy Detail
              </li>
            )}
          </ol>
        </div>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
{!loading && (
   <div className="content-body">
   <div className="container-fluid">
     <div className="card">
       <div className="card-header">
         {urllink === "addacademy" && (
           <h2 className="main-content-title tx-24 mg-b-5">Add Academy</h2>
         )}
         {urllink === "academydetail" && (
           <h2 className="main-content-title tx-24 mg-b-5">
             Academy Detail
           </h2>
         )}
       </div>
       <div className="card-body">
         <div className="row">
           <div className="col-xl-3 col-lg-4">
             <label className="form-label ">
               Logo<span className="text-danger"> *</span>
             </label>
             <div className="avatar-upload">
               <div className="avatar-preview">
                 <img
                   src={purl}
                   onError={(e) => errorphoto(e)}
                   alt="Student"
                 />
               </div>
               <div className="change-btn mt-2 mb-lg-0 mb-3">
                 <input
                   type="file"
                   className="form-control"
                   accept=".png, .jpg, .jpeg"
                   onChange={photofile}
                 />
                 {photoerror !== "" && (
                   <span className="text-danger">{photoerror}</span>
                 )}
                 <a
                   className="btn btn-secondary my-2"
                   onClick={() => {
                     setPUrl("");
                     setPFile("");
                   }}
                 >
                   Remove
                 </a>
               </div>
             </div>
           </div>
           <div className="col-xl-9 col-lg-8">
             <div className="row">
               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     Academy Name
                     <span className="text-danger"> *</span>
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter Academy Name"
                     onChange={(e) => setAName(e.target.value)}
                     value={aname}
                   />
                   {aerror && aname === "" && (
                     <span className="text-danger">
                       Please Enter Academy Name
                     </span>
                   )}
                 </div>
               </div>
               {urllink === "addacademy" && (
                 <div className="col-xl-6 col-sm-6">
                   <div className="mb-3">
                     <label className="form-label">
                       Academy Code
                       <span className="text-danger"> *</span>
                     </label>
                     <input
                       type="text"
                       className="form-control"
                       placeholder="Enter Academy Code"
                       onChange={(e) => setACode(e.target.value)}
                       value={acode}
                     />
                     {aerror && acode === "" && (
                       <span className="text-danger">
                         Please Enter Academy Code
                       </span>
                     )}
                   </div>
                 </div>
               )}

               {urllink === "academydetail" && (
                 <div className="col-xl-6 col-sm-6">
                   <div className="mb-3">
                     <label className="form-label">
                       Academy Code
                       <span className="text-danger"> *</span>
                     </label>
                     <input
                       type="text"
                       className="form-control"
                       placeholder="Enter Academy Code"
                       onChange={(e) => setACode(e.target.value)}
                       value={acode}
                       readOnly
                     />
                     {aerror && acode === "" && (
                       <span className="text-danger">
                         Please Enter Academy Code
                       </span>
                     )}
                   </div>
                 </div>
               )}
               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     Academy Type
                     <span className="text-danger"> *</span>
                   </label>
                   <select
                     className="default-select  form-control wide"
                     value={atype}
                     onChange={(e) => setAType(e.target.value)}
                   >
                     <option value="" disabled>
                       Select Academy Type
                     </option>
                     {tlist.map((item) => (
                       <option value={item.id} key={item.id}>
                         {item.name}
                       </option>
                     ))}
                   </select>
                   {aerror && atype === "" && (
                     <span className="text-danger">
                       Please Enter Academy Type
                     </span>
                   )}
                 </div>
               </div>

               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     State<span className="text-danger"> *</span>
                   </label>
                   <Select
                     className="default-select"
                     placeholder="Select State"
                     value={astate}
                     options={slist}
                     onChange={handleState}
                     isSearchable={true}
                     isClearable
                     hidden
                   />
                   {aerror && astate === "" && (
                     <span className="text-danger">
                       Please Select State
                     </span>
                   )}
                 </div>
               </div>
               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     District<span className="text-danger"> *</span>
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter District"
                     onChange={(e) => setADist(e.target.value)}
                     value={adist}
                   />
                   {aerror && adist === "" && (
                     <span className="text-danger">
                       Please Enter District
                     </span>
                   )}
                 </div>
               </div>
               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     City<span className="text-danger"> *</span>
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter City"
                     onChange={(e) => setACity(e.target.value)}
                     value={acity}
                   />
                   {aerror && acity === "" && (
                     <span className="text-danger">Please Enter City</span>
                   )}
                 </div>
               </div>

               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     Area<span className="text-danger"> *</span>
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter Area"
                     onChange={(e) => setAArea(e.target.value)}
                     value={aarea}
                   />
                   {aerror && aarea === "" && (
                     <span className="text-danger">Please Enter Area</span>
                   )}
                 </div>
               </div>
               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     Pincode<span className="text-danger"> *</span>
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter Pincode"
                     onChange={handlePin}
                     value={apin}
                     maxLength={6}
                   />
                   {aerror && apin === "" && (
                     <span className="text-danger">
                       Please Enter Pincode
                     </span>
                   )}
                 </div>
               </div>
               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">Website</label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter Website"
                     onChange={(e) => setAWebsite(e.target.value)}
                     value={awebsite}
                   />
                 </div>
               </div>

               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     Email<span className="text-danger"> *</span>
                   </label>
                   <input
                     type="email"
                     className="form-control"
                     placeholder="Enter Email"
                     onChange={(e) => setAEmail(e.target.value)}
                     value={aemail}
                   />
                   {aerror && aemail === "" && (
                     <span className="text-danger">
                       Please Enter Email
                     </span>
                   )}
                 </div>
               </div>
               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     Phone Number
                     <span className="text-danger"> *</span>
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter Phone Number"
                     onChange={handleChange}
                     value={aphone}
                     maxLength={15}
                   />
                   {aerror && aphone === "" && (
                     <span className="text-danger">
                       Please Enter Phone Number
                     </span>
                   )}
                 </div>
               </div>

               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     Student Maximum Count
                     <span className="text-danger"> *</span>
                   </label>
                   <input
                     type="text"
                     className="form-control"
                     placeholder="Enter Student Maximum Count"
                     onChange={handleCount}
                     value={acnt}
                     maxLength={10}
                   />
                   {aerror && acnt === "" && (
                     <span className="text-danger">
                       Please Enter Student Maximum Count
                     </span>
                   )}
                 </div>
               </div>

               <div className="col-xl-6 col-sm-6">
                 <div className="mb-3">
                   <label className="form-label">
                     Address <span className="text-danger"> *</span>
                   </label>
                   <textarea
                     rows="3"
                     className="form-control"
                     placeholder="Enter Address"
                     onChange={(e) => setAddr(e.target.value)}
                     value={addr}
                   />
                   {aerror && addr === "" && (
                     <span className="text-danger">
                       Please Enter Address
                     </span>
                   )}
                 </div>
               </div>
             </div>
           </div>
         </div>
         {aerrmsg !== "" && <span className="text-danger">{aerrmsg}</span>}
         <div className="res-right mt-2 me-4">
           {urllink === "addacademy" && (
             <button className="btn btn-success" onClick={submitacademy}>
               Submit
             </button>
           )}

           {urllink === "academydetail" && (
             <>
               <button
                 className="btn btn-success me-2"
                 onClick={submitacademy}
               >
                 Update
               </button>
               <button
                 className="btn btn-secondary"
                 onClick={() => navigate("/settings/allacademy")}
               >
                 Back
               </button>
             </>
           )}
         </div>
       </div>
     </div>
   </div>
 </div>
)

}
     
    </div>
  );
}
